export default __webpack_public_path__ + "static/11.13-14748759e8a4bda61d0893f82586fbf6.png";